<template>
    <blockquote class="speech up">
      <div class="speech-active">
        <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.5064 0C6.94318 0 0 7.02154 0 15.6814C0 19.4913 1.35006 22.989 3.58731 25.7066L0 32.013L7.94608 29.3734C10.1833 30.6347 12.7549 31.3629 15.5064 31.3629C24.0697 31.3629 31.0129 24.3413 31.0129 15.6814C31.0129 7.02154 24.0568 0 15.5064 0Z" fill="#FF5362"/>
          <path d="M11.5848 21.4547C9.70758 21.4547 8.07465 20.0894 8.07465 17.3198C8.07465 11.5725 11.7777 9.10198 14.4778 8.80292V11.0914C12.3563 11.5725 10.9162 13.822 10.8648 15.8115C11.0062 15.7074 11.3405 15.5644 11.8291 15.5644C13.4106 15.5644 14.7221 16.6826 14.7221 18.529C14.7221 20.1284 13.372 21.4547 11.5977 21.4547H11.5848ZM19.8138 21.4547C17.9365 21.4547 16.3036 20.0894 16.3036 17.3198C16.3036 11.5725 20.0066 9.10198 22.7067 8.80292V11.0914C20.5852 11.5725 19.1452 13.822 19.0937 15.8115C19.2352 15.7074 19.5695 15.5644 20.0581 15.5644C21.6396 15.5644 22.9382 16.6826 22.9382 18.529C22.9382 20.1284 21.5881 21.4547 19.8138 21.4547Z" fill="black"/>
        </svg>
      </div>

      <div v-if="!slide">
          Klik op een rode bol <span class="red-circle"></span> voor meer informatie
      </div>

      <div v-if="slide">

        <div class="keywords keyword-primary">
          <div class="keyword">{{slide['Hoe.oud.ben.je?']}} jaar</div>
          <div class="keyword">{{slide['GM_NAAM']}}</div>
        </div>

        <p v-if="slide['quote']"> 
          “{{slide['quote']}}”
        </p>
        
        <div class="keywords keyword-secondary">
          <div class="keyword-label">Om deze reden voel ik mij hier onveilig</div>
          <ul class="keywords">
            <li 
            v-if="slide['Reden_onve']"
            class="keyword" 
            v-for="item in slide['Reden_onve'].split(',')"
            >
            {{ redenLabel[item]}}
          </li>
        </ul>
      </div>
      
      <div class="keywords keyword-secondary">
        <div class="keyword-label">Ik pas mijn gedrag zo aan</div>
        <ul class="keywords">
          <li 
            v-if="slide['Gedrag_aan']"
            class="keyword" 
            v-for="item in slide['Gedrag_aan'].split(',')"
          >
            {{ gedrag[item]}}
        </li>
        </ul>
      </div>

      <div class="keywords keyword-secondary" v-if="slide['Tijdstip'].length > 4">
        <div class="keyword-label">Tijdstip</div>
        <div class="keywords">
          <div class="keyword">{{labelTijdstip[slide['Tijdstip']]}} </div>
        </div>
      </div>
  </div>
  </blockquote>
</template>

<script setup>
  import { defineProps, ref } from "vue";
  import { useStore } from 'vuex';
  const store = useStore();

  const props = defineProps({
    slide: Object
  });

  const gedrag = store.getters.labelsGedrag;
  const redenLabel = store.getters.labelsReden;
  const labelTijdstip = store.getters.labelTijdstip;


</script>

<style lang="scss" scoped>

.red-circle {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #FF5362;
    border: 1px solid #FFF;
  }

  .speech-active {
    display: none;
    position: absolute;
    top: -16px;
    left: 20px;
  }

  .active {
    .speech-active {
      display: block;
    }

    .speech {
      background: var( --speech-bubble-active);
    }

    .speech.up::after {
      border-bottom-color: var(--speech-bubble-active);
    }
  }



  .label {
    font-weight: bold;
  }

  .keywords {
    margin-bottom: 1rem;

    .keyword-label {
      font-weight: bold;
      font-size: 14px;
      padding-top: 10px;
      padding-bottom: 5px;
      position: relative;

      &:before {
        content: '';
        position: absolute;
        width: 20px;
        height: 3px;
        background: #000;
        top: 0;
      }
    }

    .keyword {
      margin-right: 1rem;
      padding: 1rem 1rem .5rem 1rem;
      line-height: 1.1;
      margin-bottom: 0.5rem;
    }

    &.keyword-primary {
      display: flex;
      flex-wrap: wrap;
      
      .keyword {
        font-family: var(--font-header);
        background: #FFF;
        border-radius: 4px;
      }
    }

    &.keyword-secondary {
      .keywords {
        list-style-type: disc;
      }

      .keyword {
        // border: 1px solid #000;
        padding: 0 0 0.5rem;
        margin: 0;
      }
    }



  }

  .speech {
  /* (A1) FONT & COLORS */
  font-size: 1.2em;
  color: #000;
  background: var( --speech-bubble);

  /* (A2) DIMENSIONS */
  padding: 30px 20px 20px;
  border-radius: 10px;
  max-width: 600px;
  // transform: translateY(20px);
}


/* (D) POSITION THE CALLOUT */
.speech {
  position: relative;
  margin: 30px 0;
}
.speech::after { position: absolute; }
.speech.up::after {
  top: -15px; left: calc(50% - 15px);
}

/* (B) USE ::AFTER TO CREATE THE "CALLOUT" */
.speech::after {
  display: block; width: 0; content: "";
  border: 15px solid transparent;
}
 
/* (C) "CALLOUT" DIRECTIONS */
.speech.up::after {
  border-bottom-color: var( --speech-bubble);
  border-top: 0;
}

</style>